import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const appsCatalogFields = "/apps/catalog_fields";

export const appsCatalogFieldsCacheKeys: AllRouteEndpoints[] = ["/apps/catalog_fields"];
